import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '..'

const PayLaterEmi = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M26.788 14v3.712a.827.827 0 0 1-.826.826h-5.774a.828.828 0 0 1-.825-.826v-2.474a.827.827 0 0 1 .825-.825h4.95v-1.238h.824a.828.828 0 0 1 .826.825Zm-4.538 2.475a.824.824 0 1 0-1.648 0 .824.824 0 0 0 1.648 0Z"
        fill="#70AFFF"
      />
      <Path
        d="m23.34 1.212 3.448 9.81-1.65.59V9.05a.828.828 0 0 0-.825-.825h-.681l-1.163-3.308a1.589 1.589 0 0 1-2.034-.974L8.423 8.21v.016H4.925c-.102 0-.204-.008-.305-.025l-.107-.297 14.041-4.991 4.785-1.7Z"
        fill="#FFC839"
      />
      <Path
        d="M2.904 6.563a2.057 2.057 0 0 0 2.021 1.662h19.387a.828.828 0 0 1 .825.825v5.362h-4.95a.828.828 0 0 0-.825.825v2.475a.827.827 0 0 0 .826.826h4.95v4.537c0 .5-.739 1.238-1.65 1.238h-5.776v-6.6a.827.827 0 0 0-.825-.826h-13.2a.828.828 0 0 0-.824.825v6.6a1.65 1.65 0 0 1-1.65-1.65V6.576A2.475 2.475 0 0 1 3.688 4.1h1.324A2.123 2.123 0 0 0 2.87 5.96c-.02.202-.01.405.033.603Z"
        fill="#54A0FF"
      />
      <Path
        d="m22.469 4.917 1.163 3.308H8.423v-.016l12.012-4.266a1.59 1.59 0 0 0 2.034.974Z"
        fill="#FFE193"
      />
      <Path
        d="M21.425 17.3a.825.825 0 1 0 0-1.65.825.825 0 0 0 0 1.65Z"
        fill="#2B2B37"
      />
      <Path
        d="m9.718 4.1 7.995-2.887.825 1.65.016.049L4.513 7.903l.107.297a2.057 2.057 0 0 1-1.716-1.637L9.718 4.1Z"
        fill="#FFC839"
      />
      <Path
        d="M9.718 4.1 2.904 6.563a1.946 1.946 0 0 1-.033-.603A2.123 2.123 0 0 1 5.01 4.1h4.707Z"
        fill="#2674C9"
      />
      <Path
        d="M17.713 24.313v1.65a.827.827 0 0 1-.825.825h-13.2a.828.828 0 0 1-.825-.826V20.6h14.85v3.712Z"
        fill="#FFC839"
      />
      <Path d="M17.713 19.363V20.6H2.863v-1.238H17.713Z" fill="#EDF4FA" />
      <Path
        d="M17.713 17.712v1.65H2.863v-1.65a.827.827 0 0 1 .825-.825h13.2a.828.828 0 0 1 .825.825Z"
        fill="#FFC839"
      />
      <Path
        d="M16.888 25.55H12.35a7.421 7.421 0 0 1-6.993-4.95H2.863v5.362a.827.827 0 0 0 .825.826h13.2a.828.828 0 0 0 .825-.826v-1.237a.825.825 0 0 1-.825.825Z"
        fill="#E2B34A"
      />
      <Path
        d="M5.357 20.6a7.374 7.374 0 0 1-.32-1.238H2.862V20.6h2.494Z"
        fill="#C1CFE8"
      />
      <Path
        d="M5.036 19.363a7.462 7.462 0 0 1-.11-1.238l-.001-1.238H3.688a.828.828 0 0 0-.825.825v1.65h2.173ZM18.538 2.862l-.335-.67L5.675 6.717a.825.825 0 0 1-1.046-.469l-.108-.269-1.617.585A2.057 2.057 0 0 0 4.62 8.2l-.107-.297 14.041-4.991-.016-.05Z"
        fill="#E2B34A"
      />
      <Path
        d="M11.862 6.987H7.089l-2.576.916.107.297c.1.017.203.025.305.025h3.498v-.016l3.439-1.221ZM26.788 11.022l-1.419-4.035H23.2l.435 1.238h.678a.827.827 0 0 1 .825.825v2.562l1.65-.59Z"
        fill="#E2B34A"
      />
      <Path
        d="M11.862 6.987 8.423 8.21v.016h15.209l-.435-1.237H11.862Z"
        fill="#E2B34A"
      />
      <Path
        d="M26.375 17.712H22.25a1.23 1.23 0 0 1-.925-.422.82.82 0 0 1 0-1.63 1.23 1.23 0 0 1 .925-.422h2.887a.825.825 0 0 0 .825-.825v-1.238h-.825v1.237h-4.95a.828.828 0 0 0-.825.825v2.475a.827.827 0 0 0 .826.826h5.774a.828.828 0 0 0 .826-.826V17.3a.412.412 0 0 1-.413.412Z"
        fill="#338DEF"
      />
      <Path
        d="M20.6 19.775h4.537v-1.237h-4.95a.815.815 0 0 1-.412-.116v.528a.825.825 0 0 0 .825.825Z"
        fill="#70AFFF"
      />
      <Path
        d="M2.863 19.363v-1.65a.827.827 0 0 1 .825-.826h.825V8.175a2.053 2.053 0 0 1-1.61-1.612 1.946 1.946 0 0 1-.032-.603A2.123 2.123 0 0 1 5.01 4.1H3.689a2.475 2.475 0 0 0-2.475 2.475v16.088a1.65 1.65 0 0 0 1.65 1.65v-4.95Z"
        fill="#338DEF"
      />
      <Path
        d="M23.9 22.663h-3.3a1.65 1.65 0 0 1-1.65-1.65V18.95a.825.825 0 0 0-.825-.825h-.413v6.188h5.776c.911 0 1.65-.739 1.65-1.238v-1.65a1.238 1.238 0 0 1-1.238 1.238Z"
        fill="#70AFFF"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h28v28H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default PayLaterEmi
